<template>
  <v-overlay :value="loadingDownloadData" absolute  :opacity="opacity" :z-index="zIndex">
    <center>
      <img width="130" :src="require('@/assets/img/consultation.gif')" />
    </center>
    <div class="text-center;" style="text-align: center">
      <v-chip color="#077893">{{ $t("overlay.checkRole") }}</v-chip>
      <br>
      <v-layout row wrap justify-center align-center pt-3>
        <v-flex xs11 sm11 md11 lg11>
        <b class="white--text">หมายเหตุ : {{ Message }}</b>
        </v-flex>
      </v-layout>
    </div>
  </v-overlay>
</template>
<script>
export default {
  name: 'portal_overlay_seacrh',
  props: ['Message'],
  data: () => ({
    loadingDownloadData: true,
    opacity: 0.9,
    zIndex: 0
  })
}
</script>
